/*
  rk-bundle: Bundle-Auswahl auf der Produktseite (ersetzt Kaching Bundles).
  - Auswahl der Option (Radio), Farbwahl je Stück, Upsells an/aus
  - setzt input[name="id"] im Produktformular auf die Variante von Stück 1
    (Galerie, Preis, Sticky-Leiste in rk-main-product.js reagieren darauf)
  - fängt das Absenden des Formulars ab und legt alle Positionen in einem
    Request über /cart/add.js in den Warenkorb, danach öffnet der Cart Drawer
  Preise/Rabatte: siehe snippets/rk-bundle.liquid
*/
(function () {
  if (customElements.get('rk-bundle')) return;

  class RkBundle extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.root = this.closest('.rk-pdp') || document;
      this.form = this.root.querySelector('form[data-type="add-to-cart-form"]');
      this.idInput = this.form ? this.form.querySelector('input[name="id"]') : null;
      this.options = Array.from(this.querySelectorAll('[data-rk-option]'));

      this.addEventListener('change', (e) => {
        const t = e.target;
        if (t.matches('.rk-bundle__radio')) this.select(Number(t.value));
        else if (t.matches('[data-rk-upsell], [data-rk-upsell-variant]')) this.sync();
      });

      this.addEventListener('click', (e) => {
        const chip = e.target.closest('[data-rk-chip]');
        if (chip && !chip.disabled) this.pick(chip);
      });

      if (this.form) {
        /* capture: läuft vor dem Submit-Handler von product-form.js */
        this.form.addEventListener('submit', (e) => this.submit(e), true);
      }

      document.addEventListener('rk:bundle-pick', (e) => this.pickValue(e.detail));

      const start = this.options.findIndex((o) => o.classList.contains('is-selected'));
      this.select(start < 0 ? 0 : start);
      this.classList.add('is-ready');
    }

    get current() {
      return this.options.find((o) => o.classList.contains('is-selected')) || this.options[0];
    }

    select(index) {
      this.options.forEach((opt, i) => {
        const on = i === index;
        opt.classList.toggle('is-selected', on);
        const radio = opt.querySelector('.rk-bundle__radio');
        if (radio) radio.checked = on;
        const panel = opt.querySelector('[data-rk-panel]');
        if (panel) panel.inert = !on;
      });
      this.sync();
    }

    pick(chip) {
      const group = chip.closest('[data-rk-unit]');
      if (!group) return;
      group.querySelectorAll('[data-rk-chip]').forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
      this.sync();
    }

    /* Farbe von außen wählen (z. B. „Auswählen“ in rk-feature-grid) – setzt Stück 1 der aktuellen Option */
    pickValue(value) {
      if (!value) return;
      const needle = String(value).trim().toLowerCase();
      const group = this.current && this.current.querySelector('[data-rk-unit]');
      if (!group) return;
      const chip = Array.from(group.querySelectorAll('[data-rk-chip]')).find(
        (c) => (c.dataset.value || '').trim().toLowerCase() === needle
      );
      if (chip && !chip.disabled) this.pick(chip);
    }

    unitVariants(opt) {
      const qty = Number(opt.dataset.qty || 1);
      const groups = Array.from(opt.querySelectorAll('[data-rk-unit]'));
      const fallback = this.dataset.variant;
      const ids = [];
      for (let i = 0; i < qty; i++) {
        const chip = groups[i] && groups[i].querySelector('[data-rk-chip][aria-pressed="true"]');
        ids.push(chip ? chip.dataset.variant : fallback);
      }
      return ids;
    }

    items() {
      const opt = this.current;
      const map = new Map();
      const add = (id, qty) => {
        if (!id || !qty) return;
        const key = String(id);
        map.set(key, (map.get(key) || 0) + qty);
      };
      this.unitVariants(opt).forEach((id) => add(id, 1));
      if (opt.dataset.partner) add(opt.dataset.partner, 1);
      opt.querySelectorAll('[data-rk-upsell-row]').forEach((row) => {
        const input = row.querySelector('[data-rk-upsell]');
        if (!input || !input.checked) return;
        const select = row.querySelector('[data-rk-upsell-variant]');
        add(select ? select.value : input.dataset.variant, Number(input.dataset.qty || 1));
      });
      return Array.from(map, ([id, quantity]) => ({ id: Number(id), quantity }));
    }

    sync() {
      const opt = this.current;
      if (!opt) return;
      opt.querySelectorAll('[data-rk-upsell-row]').forEach((row) => {
        const input = row.querySelector('[data-rk-upsell]');
        row.classList.toggle('is-checked', !!(input && input.checked));
      });
      const first = this.unitVariants(opt)[0];
      if (this.idInput && first && this.idInput.value !== String(first)) {
        this.idInput.value = first;
        this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    submit(e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const productForm = this.form.closest('product-form');
      const button = this.form.querySelector('[type="submit"]');
      if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

      const items = this.items();
      if (!items.length) return;

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const spinner = button.querySelector('.loading__spinner');
      const setError = (msg) => {
        if (productForm && typeof productForm.handleErrorMessage === 'function') productForm.handleErrorMessage(msg || false);
      };

      setError(false);
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');

      const body = { items };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }

      const config = typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' } };
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify(body);

      const url = (window.routes && window.routes.cart_add_url) || '/cart/add';
      let failed = false;

      fetch(url, config)
        .then((r) => r.json())
        .then((response) => {
          if (response.status) {
            failed = true;
            if (typeof publish === 'function') {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'rk-bundle',
                productVariantId: items[0].id,
                errors: response.errors || response.description,
                message: response.message,
              });
            }
            setError(response.description || response.message);
            return;
          }
          if (!cart) {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }
          if (typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: items[0].id, cartData: response });
          }
          cart.renderContents(response);
        })
        .catch((err) => {
          failed = true;
          console.error(err);
          setError('Das hat leider nicht geklappt. Bitte versuche es noch einmal.');
        })
        .finally(() => {
          button.classList.remove('loading');
          button.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
          if (!failed && cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        });
    }
  }

  customElements.define('rk-bundle', RkBundle);
})();
